import { Sparkles } from "lucide-react";

const hubItems = [
  "Caregiver support & respite relief",
  "Youth leadership & mentorship",
  "Family counseling & resource guidance",
  "Veteran support & resource coordination",
  "Community outreach & wellness programs",
  "Health advocacy & wellness initiatives",
];

export default function VisionHub() {
  return (
    <section id="vision" data-testid="vision-hub-section" className="bg-[#FAF8F5] border-y border-[#E2DCD0]">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 py-24 sm:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="text-xs tracking-[0.22em] uppercase font-bold text-[#8B2635] mb-4">
              Building What's Next
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl text-[#2C2A29] leading-[1.05] tracking-tight">
              A Community Resource Center &amp; <span className="italic text-[#692128]">Family Support Hub</span>.
            </h2>
            <p className="mt-6 text-[#5C5856] text-lg leading-relaxed">
              A single, welcoming place — under one roof — where families, caregivers,
              veterans, and neighbors can find the help they need, the dignity they deserve,
              and the community they belong to.
            </p>

            <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
              {hubItems.map((item) => (
                <li key={item} className="flex items-start gap-3 text-[#2C2A29]">
                  <Sparkles size={16} className="text-[#C89F5D] mt-1.5 shrink-0" strokeWidth={2.2} />
                  <span className="text-[15px] leading-snug">{item}</span>
                </li>
              ))}
            </ul>

            <div className="mt-10 rounded-2xl border border-[#D5C9B3] bg-[#F4F1EB] p-6">
              <p className="font-serif text-xl text-[#2C2A29] leading-snug italic">
                “A safe, loving, and empowering place where families can grow stronger together.”
              </p>
            </div>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="relative aspect-[5/4] rounded-3xl overflow-hidden shadow-xl">
              <img
                src="https://images.unsplash.com/photo-1768059753701-f4099bca3eff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBidWlsZGluZyUyMG5hdHVyZSUyMHN1bmxpZ2h0fGVufDB8fHx8MTc3ODY5MDg2Mnww&ixlib=rb-4.1.0&q=85"
                alt="A welcoming community space"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-6 left-6 right-6 bg-[#F4F1EB]/85 backdrop-blur-xl border border-[#E2DCD0] rounded-2xl px-5 py-4 flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-[#692128] text-[#F4F1EB] flex items-center justify-center font-serif text-lg">G</div>
                <div>
                  <div className="text-[10px] tracking-[0.22em] uppercase text-[#8B2635] font-bold">Coming Soon</div>
                  <div className="font-serif text-lg text-[#2C2A29] leading-tight">The Guardian Grace Hub</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
